import { render, staticRenderFns } from "./SortField.vue?vue&type=template&id=623601ce&scoped=true&"
import script from "./SortField.vue?vue&type=script&lang=js&"
export * from "./SortField.vue?vue&type=script&lang=js&"
import style0 from "./SortField.vue?vue&type=style&index=0&id=623601ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623601ce",
  null
  
)

export default component.exports